import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { LevStandardQueryMeta } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'insurancePolicy/history/charts';

export const usePolicyHistoryChartsQuery = ({
	filter,
	charts,
	enabled,
	refetchOnWindowFocus = false,
}: {
	filter: Api.IPolicyHistoryChartFilter;
	charts: Api.IPolicyHistoryChartQuery[];
	enabled?: boolean;
	refetchOnWindowFocus?: boolean;
}) => {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		// The tab explains a failure inline, so no toast and no long retry backoff before it can.
		retry: 1,
		queryFn: () =>
			userSession.webServiceHelper.callAsync<Api.IPolicyHistoryChartsResponse>(
				Api.ImpersonationBroker.composeApiUrl({ urlPath: BASE_QUERY_KEY }),
				'POST',
				{ filter, charts }
			),
		queryKey: [BASE_QUERY_KEY, filter, charts],
		refetchOnWindowFocus,
		meta: {
			errorLogging: { category: 'PolicyHistory', action: 'PolicyHistoryChartsQuery-Error' },
		} satisfies LevStandardQueryMeta,
	});
};
